const staticData = {
    static: {
        sections: [
            {
                title: 'Top Searches',
                slug: 'top-searches',
                searches: [
                    {
                        title: 'snowcone',
                    },
                    {
                        title: 'disney princess',
                    },
                    {
                        title: 'red white woof',
                    },
                    {
                        title: 'grilling season',
                    },
                    {
                        title: 'rainbow sprinkles',
                    },
                    {
                        title: 'rainbow poppies',
                    },
                    {
                        title: "very cherry",
                    },
                    {
                        title: 'pink magnolias',
                    },
                    {
                        title: 'rainbow hearts',
                    },
                    {
                        title: 'velour',
                    },
                    {
                        title: 'sherpa',
                    },
                ],
            },
            {
                title: 'Top Classes + Events',
                slug: 'top-classes-events',
                classes: [
                    {
                        title: 'Perinatal Yoga with Carla Jian',
                        url: '/products/prenatal-yoga-with-carla-primero',
                    },
                    {
                        title: 'Pre- and Post-Natal Health Series with Kenna Johnson',
                        url: '/products/pre-and-post-natal-health-series-with-kenna-johnson',
                    },

                    {
                        title: 'Infant First Aid + CPR',
                        url: '/products/infant-first-aid-and-cpr',
                    },
                ],
            },
            {
                title: 'Top Categories',
                slug: 'top-categories',
                categories: [
                    {
                        title: 'Rompers + Bodysuits',
                        url: '/collections/all-rompers',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-flyout-rompers-pinkelep_otg.jpg?v=1644893463',
                        imageAlt: 'On the Go One-Piece in Pink Elephant print',
                    },
                    {
                        title: 'Blankets',
                        url: '/collections/baby-blankets',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/pizza_ocb.jpg?v=1660150983',
                        imageAlt: 'Coming Home Blanket in Pizza Party print',
                    },
                    {
                        title: 'Dresses',
                        url: '/collections/all-dresses',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/snowcone_ldd_068.jpg?v=1682464315',
                        imageAlt:
                            "Let's Dance Dress in Snowcone Celebration print",
                    },
                    {
                        title: 'Pajamas',
                        url: '/collections/all-pajamas',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/rwb-dogs_2pc-pjs_111.jpg?v=1682463969',
                        imageAlt: 'Two-Piece Pajamas in Red, White + Woof print',
                    },
                    {
                        title: 'Gifts + Sets',
                        url: '/collections/baby-gifts',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-gifts-sets.jpg?v=1643759446',
                        imageAlt: 'Hospital Cuddle Box in Pink Rainbow',
                    },
                    {
                        title: 'Nursery + More',
                        url: '/pages/shop-all-nursery-more',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-nursery-more.jpg?v=1643759446',
                        imageAlt: 'Babyletto crib in White',
                    },
                    {
                        title: 'Accessories',
                        url: '/collections/all-accessories',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/navyelep_cap_de12b2fe-f875-4a74-9179-aef2c28f2142_2.jpg?v=1655232816',
                        imageAlt: 'Top Knot Cap in Navy Elephant',
                    },
                    {
                        title: 'Robes',
                        url: '/collections/organic-lounge-robes',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/search-static-robes.jpg?v=1643759446',
                        imageAlt:
                            'Organic Lounge Robe in grey folded with a bow',
                    },
                ],
            },
        ],
    },
}

export default staticData
